var __TEMP__ = require('./_baseGet.js');var baseGet = __REQUIRE_DEFAULT__(__TEMP__);
var __TEMP__ = require('./_baseSlice.js');var baseSlice = __REQUIRE_DEFAULT__(__TEMP__);

/**
 * Gets the parent value at `path` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} path The path to get the parent value of.
 * @returns {*} Returns the parent value.
 */
function parent(object, path) {
  return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
}

if (!exports.__esModule) Object.defineProperty(exports, "__esModule", { value: true });exports.default = parent;
